import { Box, Chip, Typography } from "@mui/material";
import styled from "@emotion/styled";
import theme from "../../../theme";

export const QuickReplyListWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 24px;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

export const QuickReplyListItem = styled(Chip)`
  border-radius: 100px;
  word-wrap: break-word;
  min-width: 80px;
  width: fit-content;
  height: auto;
  padding: 16px 12px;

  .MuiChip-label {
    overflow: visible;
    text-overflow: unset;
    white-space: wrap;
    font-size: 14px;
    width: fit-content;
    text-align: center;
  }
`;

export const QuickReplyModalHeader = styled(Box)`
  position: relative;
  padding: 12px 16px 12px 24px;
  border-bottom: 1px solid ${theme.palette.divider};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const QuickReplyTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const QuickReplyActions = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const QuickReplyModalBody = styled(Box)`
  min-height: 260px;
  display: flex;
  justify-content: center;
`;

export const EmptyQuickReplies = styled(Typography)`
  margin-top: 40px;
`;

export const QuickReplyWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  padding: 24px;
  justify-content: center;
  width: 100%;
`;

export const PriorityMessageLabel = styled(Box)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
`;
